import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=3be5476a"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=3be5476a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports